<ng-container *ngIf="config">
  <i class="fas fa-sort-amount-down" 
    [class.voltear]="direction === 'asc'" 
    [class.filter-active]="id===config.active && direction===config.direction" 
    (click)="select()">
  </i>
</ng-container>